var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsEnum, IsString, ValidateNested } from 'class-validator';
import { Role } from '../../roles/enums/role.enum.js';
import { TrainingReminderTime } from '../../user/enums/training-reminder-time.enum.js';
/** The email switch of every settings category, under the names `UserSettings` gives them. */
export class NotificationSettingsEmailSwitchesDto {
    emailNotificationRegistrationEnabled;
    emailNotificationShopEnabled;
    emailNotificationPatientHandOverEnabled;
    emailNotificationAppointmentEnabled;
    emailNotificationExerciseProgramEnabled;
    emailNotificationTrainingReminderEnabled;
    emailNotificationProgramStatsEnabled;
    emailNotificationInvoicesEnabled;
}
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationRegistrationEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationShopEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationPatientHandOverEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationAppointmentEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationExerciseProgramEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationTrainingReminderEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationProgramStatsEnabled", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], NotificationSettingsEmailSwitchesDto.prototype, "emailNotificationInvoicesEnabled", void 0);
/**
 * What the settings link of a notification mail opens (TM-9527): one Person's
 * email switches and training reminder send time, and of the Person only what
 * the mail itself already shows — the office's name and the Person's first
 * name. The role decides which categories the page offers. Nothing else of the
 * Person: the page opens for whoever holds the link.
 */
export class NotificationSettingsPublicResponseDto {
    firstName;
    officeName;
    role;
    emailSwitches;
    trainingReminderTime;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], NotificationSettingsPublicResponseDto.prototype, "firstName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], NotificationSettingsPublicResponseDto.prototype, "officeName", void 0);
__decorate([
    Expose(),
    IsEnum(Role),
    __metadata("design:type", String)
], NotificationSettingsPublicResponseDto.prototype, "role", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => NotificationSettingsEmailSwitchesDto),
    __metadata("design:type", NotificationSettingsEmailSwitchesDto)
], NotificationSettingsPublicResponseDto.prototype, "emailSwitches", void 0);
__decorate([
    Expose(),
    IsEnum(TrainingReminderTime),
    __metadata("design:type", String)
], NotificationSettingsPublicResponseDto.prototype, "trainingReminderTime", void 0);
//# sourceMappingURL=notification-settings-public.response.dto.js.map